export default "__VITE_ASSET__afc0dfb9__"